export class GeneralSettings {
  /**
   * Nurodo kiek laiko nuo srities aliarminės būsenos bus rodomas "Take action" mygtukas.
   * **Sekundėmis!**
   */
  public static takeActionButtonDuration = 300;
}
